export const env = {
  DEV: import.meta.env?.DEV ?? false,
  get(key: string) {
    return import.meta.env?.[key];
  },
};
